<div class="clug-page assignments-page">
  <div class="page-head">
    <div class="title-block">
      <h1 class="page-title">Assignments</h1>
      <p class="lede">Track contractor-to-job assignments across every client.</p>
    </div>
    <div class="action-bar">
      <button type="button" class="btn btn-primary" (click)="onAdd()">
        <i class="bi bi-plus-lg"></i><span>Add New</span>
      </button>
    </div>
  </div>

  <nav class="page-tabs">
    <a class="page-tab" routerLinkActive="active" routerLink="/assignments/active-assignments">Active</a>
    <a class="page-tab" routerLinkActive="active" routerLink="/assignments/inactive-assignments">Inactive</a>
    <a *ngIf="user?.role_uuid === ROLES?.CANDIDATE"
       class="page-tab" routerLinkActive="active" routerLink="/assignments/assignment-requests">Requests</a>
  </nav>

  <router-outlet></router-outlet>
</div>
